import xIcon from "../../../../assets/box/close_clear.png";
import styles from "../session_tables.module.css";
import { useEffect, useRef, useState, useCallback } from "react";

const AttendeesTableModal = (props) => {
  const { users, close, title, position, isOpen, triggerId } = props;
  const modalRef = useRef(null);
  const [adjustedPosition, setAdjustedPosition] = useState(position);

  // Ajusta la posición para que no se salga de la pantalla
  const adjustPosition = useCallback((pos) => {
    if (!pos) return pos;

    const modalWidth = 280; // Ancho aproximado del modal en px
    const modalHeight = 300; // Alto aproximado del modal en px
    const margin = 10;

    let adjustedX = pos.x;
    let adjustedY = pos.y;

    // Ajustar posición horizontal
    if (pos.x + modalWidth > window.innerWidth) {
      adjustedX = pos.x - modalWidth - margin;
    }

    // Ajustar posición vertical
    if (pos.y + modalHeight > window.innerHeight) {
      adjustedY = window.innerHeight - modalHeight - margin;
    }

    // Asegurar que no se salga por arriba
    if (adjustedY < margin) {
      adjustedY = margin;
    }

    return { x: adjustedX, y: adjustedY };
  }, []);

  // Efecto para ajustar posición inicial
  useEffect(() => {
    if (position) {
      setAdjustedPosition(adjustPosition(position));
    }
  }, [position, adjustPosition]);

  // Efecto para cerrar modal al hacer scroll
  useEffect(() => {
    const handleScroll = () => {
      close();
    };

    if (isOpen) {
      window.addEventListener('scroll', handleScroll, true);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [isOpen, close]);

  // Cierra el modal si se hace clic fuera de él
  useEffect(() => {
    const handleClickOutside = (event) => {
      // No cerrar si el clic fue en el icono que activó este modal
      const clickedElement = event.target;
      const isTriggerIcon = clickedElement.closest(`[data-session-id="${triggerId}"]`);

      if (modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !isTriggerIcon) {
        close();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, close, triggerId]);

  // Manejar tecla Escape
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        close();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, close]);

  if (!isOpen || !adjustedPosition) return null;

  return (
    <div
      ref={modalRef}
      className={styles.modalContainer}
      style={{
        position: "fixed",
        left: `${adjustedPosition.x}px`,
        top: `${adjustedPosition.y}px`,
        transform: "none",
        margin: 0,
        zIndex: 1000,
      }}
    >
      <img src={xIcon} alt="Close" className={styles.xIcon} onClick={close} />
      <div className={styles.headerModal}>{title}</div>
      <div className={`table-rows ${styles.rowPop}`}>
        {users.map((user, i) => {
          const dark = i % 2 === 0;
          return (
            <div
              key={user.idUser}
              className={`content-box gray ultimo ${styles.rowModal} ${dark && styles.dark
                }`}
            >
              {user.firstname + " " + user.lastname}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AttendeesTableModal;